import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiniTourComponent } from './mini-tour.component';
import { LightImageModule } from '../light-image/light-image.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MotePipesModule } from '../../pipes';
import { LoadingComponentModule } from '../loading/loading.module';



@NgModule({
    declarations: [
        MiniTourComponent
    ],
    imports: [
        CommonModule,
        LightImageModule,
        SvgIconModule,
        MotePipesModule,
        LoadingComponentModule,
    ],
    exports: [
        MiniTourComponent
    ]
})
export class MiniTourModule { }
